import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/images/shared/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-0986089d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header__container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Image logo page"
  })
], -1))
const _hoisted_3 = { class: "menu__desktop" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "00", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "01", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "02", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "03", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-bars fa-2xl" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-xmark fa-2xl" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "00", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "01", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "02", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "03", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          class: _normalizeClass([{ active: _ctx.currentPage === 'Home' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateView('Home')))
        }, [
          _hoisted_4,
          _createTextVNode(" Home ")
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass([{ active: _ctx.currentPage === 'Destination' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateView('Destination')))
        }, [
          _hoisted_5,
          _createTextVNode(" Destination ")
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass([{ active: _ctx.currentPage === 'Crew' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateView('Crew')))
        }, [
          _hoisted_6,
          _createTextVNode(" Crew ")
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass([{ active: _ctx.currentPage === 'Technology' }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateView('Technology')))
        }, [
          _hoisted_7,
          _createTextVNode(" Technology ")
        ], 2)
      ])
    ]),
    _createElementVNode("div", {
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openMenu && _ctx.openMenu(...args))),
      class: "btn__open__menu"
    }, _hoisted_9),
    _createElementVNode("div", {
      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args))),
      class: "menu__mobile"
    }, [
      _createElementVNode("div", {
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args))),
        class: "btn__close"
      }, _hoisted_11),
      _createElementVNode("nav", null, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateView('Home')))
          }, [
            _hoisted_12,
            _createTextVNode(" Home")
          ]),
          _createElementVNode("li", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateView('Destination')))
          }, [
            _hoisted_13,
            _createTextVNode(" Destination ")
          ]),
          _createElementVNode("li", {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateView('Crew')))
          }, [
            _hoisted_14,
            _createTextVNode(" Crew")
          ]),
          _createElementVNode("li", {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateView('Technology')))
          }, [
            _hoisted_15,
            _createTextVNode(" Technology")
          ])
        ])
      ])
    ])
  ]))
}